import React from 'react';

import { useAppContext } from '../hooks';

import FormError from './FormError';

function NonFieldFormErrors() {
  const { config } = useAppContext();
  return (
    config.non_field_errors.length > 0 &&
    config.non_field_errors.map((error, i) => (
      <FormError key={i} message={error} />
    ))
  );
}

export default NonFieldFormErrors;
